import { AnyAction } from 'redux';
import { AnswerEnvironmentState } from '@types';
import { answerEnvironmentInitialState } from '@reducers/initialState/answerEnvironment';
import { answerEnvironmentActionTypes } from '@actions/actionTypes/answerEnvironment';

export const answerEnvironmentReducer = (
  state = answerEnvironmentInitialState,
  action: AnyAction
): AnswerEnvironmentState => {
  switch (action.type) {
    case answerEnvironmentActionTypes.SET_ANSWER_USER: {
      return { ...state, owner: action.payload };
    }

    case answerEnvironmentActionTypes.SET_ANSWER_CONTEXT: {
      return { ...state, context: action.payload };
    }

    case answerEnvironmentActionTypes.SET_ANSWER_QUESTIONNAIRE_CONTEXT: {
      return { ...state, questionnaireContext: action.payload };
    }

    case answerEnvironmentActionTypes.SET_ANSWER_USER_ABBR: {
      return { ...state, userAbbr: action.payload };
    }

    case answerEnvironmentActionTypes.SET_ANSWER_ATTACHMENTS: {
      return { ...state, attachments: action.payload };
    }

    case answerEnvironmentActionTypes.SET_ANSWER_LANGUAGE: {
      return { ...state, lang: action.payload };
    }

    default: {
      return state;
    }
  }
};
